

/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    $.each(address, (attr) => {
        const val = address[attr];
        $(`.${attr}`, parentSelector).text(val || '');
    });
}

/*eslint-disable */
/**
 * returns a formed <option /> element
 * @param {object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {object} [options] - options
 * @returns {object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    const safeOptions = options || {};
    const isBilling = safeOptions.type && safeOptions.type === 'billing';
    const className = safeOptions.className || '';
    let isSelected = selected;
    let isNew = !shipping;
    if (typeof shipping === 'string') {
        return $(`<option class="${className}" disabled>${shipping}</option>`);
    }
    const safeShipping = shipping || {};
    let shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
    }

    const uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    const optionEl = $(`<option class="${className}" />`);
    optionEl.val(uuid);

    let title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (shippingAddress.isBRAddress) {
            title.push(order.resources.brAddressLabel);
            optionEl.attr('style', 'font-weight: bold;')
        }
        if (shippingAddress.firstName && shippingAddress.lastName) {
            title.push(`${shippingAddress.firstName} ${shippingAddress.lastName}`);
        }
        if (shippingAddress.address1 && !shippingAddress.isBRAddress) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.address2 && !shippingAddress.isBRAddress) {
            title.push(shippingAddress.address2);
        }
        if (shippingAddress.city) {
            if (shippingAddress.state) {
                title.push(`${shippingAddress.city},`);
            } else {
                title.push(shippingAddress.city);
            }
        }
        if (shippingAddress.province) {
            title.push(shippingAddress.province);
        }
        if (shippingAddress.postalCode && !shippingAddress.isBRAddress) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(', ').replace(':,', ':');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    const keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-phone': 'phone',
        'data-isBRAddress': 'isBRAddress'
    };
    $.each(keyMap, (key) => {
        const mappedKey = keyMap[key];
        let mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    const giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, (key) => {
        const mappedKey = giftObj[key];
        const mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/*eslint-disable */

/**
 * returns address properties from a UI form
 * @param {Form} form - the Form element
 * @returns {object} - a JSON object with all values
 */
function getAddressFieldsFromUI(form) {
    const address = {
        firstName: $('input[name$=_firstName]', form).val(),
        lastName: $('input[name$=_lastName]', form).val(),
        address1: $('input[name$=_address1]', form).val(),
        address2: $('input[name$=_address2]', form).val(),
        city: $('input[name$=_city]', form).val(),
        postalCode: $('input[name$=_postalCode]', form).val(),
        stateCode: $('select[name$=_stateCode],input[name$=_stateCode]', form).val(),
        countryCode: 'CA',
        phone: $('input[name$=_phone]', form).val(),
        isBRAddress: $('input[name$=_isBRAddress]', form).val()
    };
    return address;
}


module.exports = {
    methods: {
        populateAddressSummary,
        optionValueForAddress,
        getAddressFieldsFromUI
    },

    showDetails() {
        $('.btn-show-details').on('click', function (e) {
            e.preventDefault();
            const form = $(this).closest('form');

            form.find('.js-shipping-postal-code').prop('disabled', false);
            form.attr('data-address-mode', 'details');
            form.find('.shipping-address-block').removeClass('d-none');
            form.find('.multi-ship-address-actions').removeClass('d-none');
            form.find('.multi-ship-action-buttons .col-12.btn-save-multi-ship').addClass('d-none');
        });
    },

    addNewAddress() {
        $('.btn-add-new').on('click', function (e) {
            e.preventDefault();
            const $el = $(this);
            if ($el.parents('#dwfrm_billing').length > 0) {
                // Handle billing address case
                var formBilling = $('form[name=dwfrm_billing]');
                var email = $('input[name$=_email]', formBilling).val();
                var phone = $('input[name$=_phone]', formBilling).val();
                $('body').trigger('checkout:clearBillingForm');
                $('input[name$=_email]', formBilling).val(email);
                $('input[name$=_phone]', formBilling).val(phone);
                const $option = $($el.parents('form').find('.addressSelector option')[0]);
                $option.attr('value', 'new');
                const $newTitle = $('#dwfrm_billing input[name=localizedNewAddressTitle]').val();
                $option.text($newTitle);
                $option.prop('selected', 'selected');
                $el.parents('[data-address-mode]').attr('data-address-mode', 'new');
            } else {
                // Handle shipping address case
                const $newEl = $el.parents('form').find('.addressSelector option[value=new]');
                $newEl.prop('selected', 'selected');
                $(this).closest('form').attr('data-address-mode', 'details');
                $(this).closest('form').find(".shipping-address-block").removeClass("d-none");
                $newEl.parent().trigger('change');
            }
        });
    }
};
